<template>
  <div class="app_wrap">
    <!-- <div v-if="showTag" class="imp_box" id="ledToAppHeader" style>
      <h4 class="imp_h4">
        <img src="../static/images/index/miniLogo.png" width="40" height />
        <div>
          <p class="first_slogn" v-text="sloganWordtop"></p>
          <p v-text="sloganWordbottom"></p>
        </div>
      </h4>
      <span class="goindex_btn openwith_app" @click="appDownload">
        下载APP
        <span class="iconfont">&#xe742;</span>
      </span>
    </div> -->
    <transition name="slide-fade">
      <div
        v-if="showFloat"
        :class="['float_box', sliding ? 'slidein' : 'slideout']"
        @click="gotoApp"
      >
        APP打开
      </div>
    </transition>
  </div>
</template>
<script>
import getUa from "../utils/getUa";
export default {
  data() {
    return {
      name: this.$route.name,
      sloganWordtop: "",
      sloganWordbottom: "",
      showTag: false,
      showFloat: false,
      sliding: false,
      t1: 0,
      t2: 0,
      timer: null,
      objectStr: "",
      webChatFlag: false,
      aliFlag: false,
      istoutiao: false,
      badFish: getUa.userAgent.badfish,
      hideDownLoad: false,
      isLark: false,
      channel: "",
      baiduMap: getUa.userAgent.baiduMap,
      flag: false
    };
  },
  created() {
      let str = window.document.URL.toString()
    if(str.includes('/login') || str.includes('/register')){
        this.flag = true
    }

  },
  mounted() {
    this.judgeWebChat(this);
    // 判断支付宝小程序环境
    this.judgeAliChat(this);
    this.judgeToutiao(this);
    // 判断飞书
    this.judgeLark(this);
    this.checkShowApp();
    window.addEventListener("scroll", this.handleScroll);
    this.channel = this.$getParam("channel");
  },
  watch: {
    $route(to, from) {
      this.name = to.name;
      this.checkShowApp();
    },
  },
  methods: {
    handleScroll: function () {
      this.sliding = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(this.stopScroll, 300);
      this.t1 = document.documentElement.scrollTop || document.body.scrollTop;
    },
    stopScroll: function () {
      this.t2 = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.t2 == this.t1) {
        this.sliding = false;
      }
    },
    checkShowApp: function () {
      const _this = this;
      const isCloseTagExpire = function () {
        return !_this.getCookie("openappled");
      };
      // 如果在百度地图APP中隐藏下载APP的相关操作
      if (this.getStore("hideDownLoad") == "true") {
        this.hideDownLoad = true;
      }
      // 如果 utm_source=huawei&utm_content=fuwuhao  隐藏下载相关
      if (
        this.$getParam("utm_source") === "huawei" &&
        this.$getParam("utm_content") === "fuwuhao"
      ) {
        this.setStore("hideDownLoad", "true");
        this.hideDownLoad = true;
      }
      /* 注入字段及是否需要显示 */
      const slogan = _this.getStore("slogan");
      if (slogan == 1) {
        _this.setStore("slogan", 0);
      } else {
        _this.setStore("slogan", 1);
      }
      const page = _this.name;
      var daily = { words: "", btn: "", showHeader: false, float: false };
      if (page == "index" || page == "result" || page == "detail" || page == "login" || page == "register") {
        /* 首页,房源详情页,城市搜索结果页 */
        var daily = {
          wordfirst: "下载小猪APP，随时随地预订民宿",
          wordsecond: "酒店之外，就住小猪",
          showHeader: true,
          float: true,
        };
      }
      _this.sloganWordtop = daily.wordfirst;
      _this.sloganWordbottom = daily.wordsecond;
      if (
        _this.$getUa.userAgent.isalipay ||
        _this.$getUa.userAgent.isjdapp ||
        _this.$getUa.userAgent.isxzdz ||
        _this.$getUa.userAgent.isxzapp
      ) {
      } else {
        if (
          daily.showHeader &&
          isCloseTagExpire() &&
          !this.badFish &&
          !_this.webChatFlag &&
          !_this.aliFlag &&
          !_this.istoutiao &&
          !_this.isLark &&
          !_this.hideDownLoad &&
          !this.baiduMap
        ) {
          _this.showTag = true;
        } else {
          _this.showTag = false || _this.flag;
        }
        if (
          daily.float &&
          !this.badFish &&
          !_this.webChatFlag &&
          !_this.aliFlag &&
          !_this.istoutiao &&
          !_this.isLark &&
          !_this.hideDownLoad &&
          !this.baiduMap
        ) {
          _this.showFloat = true;
        } else {
          _this.showFloat = false;
        }
      }
      /* APP内打开 */
      const isClosePopExpire = function () {
        return !_this.getCookie("openappledpop");
      };
      /* 通用链接 */
    },
    appup: function () {
      const _this = this;
      let appInfo = "";
      const addStr = function (data) {
        _this.objectStr = "";
        $(Object.keys(data)).each(function (i, key) {
          _this.objectStr += key + "=" + data[key] + "&";
        });
        if (_this.objectStr !== "") {
          _this.objectStr = _this.objectStr.substr(
            0,
            _this.objectStr.lastIndexOf("&")
          );
        }
      };
      const __landlordId = _this.getStore("!landlordId");
      // 打开对应的页面
      switch (_this.name) {
        case "index":
          appInfo = { page: "index" };
          break;
        case "detail":
          var nowLuId = _this.$route.query.luId ? _this.$route.query.luId : "";
          appInfo = { page: "detail", luid: nowLuId };
          break;
        case "result":
          var luid = _this.$route.query.luid;
          appInfo = {
            page: "search",
            cityId: _this.$route.query.cityId,
            cityName: _this.$route.query.city,
          };
          break;
        default:
          appInfo = { page: "index" };
      }
      addStr(appInfo);
    },
    gotoApp: function () {
      let theTime;
      const _this = this;
      let timeout = 2;
      this.appup();
      var openApp = function () {
        timeout--;
        if (timeout == 0) {
          const endtime = Math.round(new Date().getTime() / 1000);
          if (endtime >= startTimes && endtime <= after2seconds) {
            _this.$router.push({
              name: "app",
              query: { objectStr: _this.objectStr, ban: 2 },
            });
          }
        } else {
          theTime = setTimeout(openApp, 1000);
        }
      };
      location.href = 
        "openapp.xzdz://xiaozhu/openpage?v=" +
        Math.random() +
        "&" +
        _this.objectStr;
      var startTimes = Math.round(new Date().getTime() / 1000);
      var after2seconds = startTimes + 4;
      openApp();
    },
    appDownload: function () {
      const _this = this;
      if (_this.$getUa.userAgent.iswechat) {
        location.href =
          "http://a.app.qq.com/o/simple.jsp?pkgname=com.xiaozhu.xzdz";
      } else if (_this.$getUa.userAgent.iswebo) {
        location.href = "https://m.xiaozhu.com/#/app";
      } else {
        if (_this.$getUa.userAgent.isiphone) {
          location.href =
            "https://itunes.apple.com/cn/app/xiao-zhu-duan-zu-wang/id952710115?l=zh&ls=1&mt=8";
        } else if (_this.$getUa.userAgent.isandroid) {
          this.$router.push({ name: "app", query: { channel: _this.channel } });
        }
      }
    },
    closeTag: function () {
      this.showTag = false;
      this.setCookie("openappled", "1", "7200"); // 7200
    },
  },
};
</script>

<style lang="scss" scoped>
.app_wrap {
  .imp_box {
    .imp_h4 {
      margin-left: 10px;
    }
    .openwith_app {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/toApp.vue